import { provideHttpClient } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigFacade } from '@library/store/config/config.facade';
import { HOMES_FACADE, HomesFacade } from '@library/store/homes/homes.facade';
import { EnumModulesActions } from '@library/store/modules/modules.action';
import { ModulesModule } from '@library/store/modules/modules.module';
import { ModuleSelectResolver } from '@library/store/modules/modules.resolver';
import { PageLoaderFacade } from '@library/store/page-loader/page-loader.facade';
import { RoomsFacade } from '@library/store/rooms/rooms.facade';
import { SchedulesService } from '@library/store/schedules/schedules.service';
import { UserFacade } from '@library/store/user/user.facade';
import { HeaderModule } from '@library/ui/layout/header/header.module';
import { MainModule } from '@library/ui/layout/main/main.module';
import { UIModule } from '@library/ui/ui.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { Analytics } from '@library/utils/services/analytics.service';
import { CallbackService } from '@library/utils/services/callback.service';
import { JAWG_ACCESS_TOKEN } from '@library/utils/services/jawgmaps.service';
import { NavigationCounter } from '@library/utils/services/navigation-counter.service';
import { NOTIFICATIONS } from '@library/utils/services/notifications.service';
import { UnitConverterService } from '@library/utils/services/unit-converter.service';
import { UserAgentService } from '@library/utils/services/user-agent.service';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InitLoader, InitLoaderFactory } from './loaders/init.loader';
import { SchedulesServiceVelux } from './stores/schedules/schedules.service';
import { StateModule } from './stores/state.modules';
import { BlockBackButtonGuard } from './views/block-back-button.guard';
import { HomeViewModule } from './views/home-view/home-view.module';
import { ClimateAutoSettingsService } from './views/schedule-automations-view/room-automations-page/climate-algo-settings-view/climate-auto-settings.services';
import { AirQualityService } from './views/schedule-automations-view/room-automations-page/iaq-dashboard-view/iaq-dashboard-view.service';
import { UsersPageModule } from './views/users-view/users-view.module';

const appModules = [
  AppRoutingModule,
  MainModule,
  HeaderModule,
  PipesModule,
  BrowserAnimationsModule,
  StateModule,
  UIModule,
  ModulesModule,
  HomeViewModule,
  UsersPageModule,
];

const appServices = [
  CallbackService,
  UserAgentService,
  DeviceDetectorService,
  CookieService,
  NavigationCounter,
  UnitConverterService,
  SchedulesServiceVelux,
  ClimateAutoSettingsService,
];

const providers = [
  ConfigFacade,
  RoomsFacade,
  UserFacade,
  HomesFacade,
  PageLoaderFacade,
  ModuleSelectResolver,
  {
    provide: NOTIFICATIONS,
    useValue: [
      {
        message: 'common-settings.__MOVE_MODULE_SUCCESS',
        iconName: 'check',
        timeToDisplay: 8000,
        actionType: EnumModulesActions.UpdateModuleNameSuccess,
        notificatonType: 'success',
      },
    ],
  },
  provideAppInitializer(() => {
    const initializerFn = (InitLoaderFactory)(inject(InitLoader));
    return initializerFn();
  }),
  {
    provide: JAWG_ACCESS_TOKEN,
    useValue: 'r2x1Mq25Fg4u3Wg3AMVjGeKCPGDH8aU01G0AvfWTdmOESilW9KfsFxYIgJdU4d8u',
  },
  {
    provide: HOMES_FACADE,
    useExisting: HomesFacade,
  },
  {
    provide: SchedulesService,
    useClass: SchedulesService,
  },
  AirQualityService,
  BlockBackButtonGuard,
  Analytics,
  provideHttpClient(),
];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    ...appModules,
  ],
  providers: [
    ...appServices,
    ...providers,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
